import useFetch from "../../../hooks/useFetch";

/**
 * Submits first-class (type = 1) parent feedback via a manual POST.
 * @returns {{ mutate: Function, loading: boolean, error: Error|null }}
 */
export const useSubmitFirstClassFeedback = () => {
  return useFetch("/storeParentFeedback", { method: "post", manual: true });
};
